const getPersonConcernedChildren = (response, url, id) => {
  let personConcernedChildren = [
    "ФИО",
    "Адрес, телефон",
    "Документ, удостоверяющий личность, идентификационный номер",
  ];

  if (url === 2 && id < 10) {
    personConcernedChildren = [
      "Наименование",
      "Адрес, телефон",
      {
        key: "leRegData",
        title: response.leRegData,
      },
      "Наименование государственной организации, осуществившей государственную регистрацию",
      "Номер в ЕГР",
      "УНП",
    ];
  }

  if (id >= 10) {
    personConcernedChildren.push("Число, месяц, год рождения", "Место рождения");
  }

  if (id >= 10 && url === 2) {
    personConcernedChildren.push("Гражданство");
  }

  return personConcernedChildren;
};

export const structuredData = (response, type = "app", url = 1, id) =>
  [
    {
      key: "addressee",
      title: response.addressee,
      textarea: true,
      rows: 3,
    },
    {
      key: "heading",
      title: response.heading,
      textarea: true,
      rows: 3,
    },
    {
      key: type === "modif" ? "baseData" : "baseText",
      title: response[type === "modif" ? "baseData" : "baseText"],
      ...(type === "modif" && {
        textarea: true,
        rows: 2,
      }),
      ...((id > 14 || id === 10 || id === 11) && {
        children: [id > 14 ? "Причина обмена" : "Название программы"],
      }),
      ...(id > 14 && {
        childContainerStyle: "child__container-style",
      }),
    },
    ...(id === 11
      ? [
          {
            key: "checkForm",
            title: response.checkForm,
          },
          {
            key: "checkFormPlug",
            title: "Теория или практика",
            mode: "view",
          },
        ]
      : []),
    ...(id === 13
      ? [
          {
            key: "boatType",
            title: response.boatType,
          },
          {
            key: "boatTypePlug",
            title: "Моторное/Парусное",
            mode: "view",
          },
          {
            key: "swimmingArea",
            title: response.swimmingArea,
          },
          {
            key: "swimmingAreaPlug",
            title: "ВВП/М",
            mode: "view",
          },
        ]
      : []),
    ...(id === 12 || id === 13
      ? [
          {
            key: "examDataTheoretical",
            title: response.examDataTheoretical,
            textarea: true,
            rows: id === 12 ? 3 : 2,
          },
          {
            key: "examDataTheoreticalPlug",
            title: "Дата и номер протокола по теории",
            mode: "view",
          },
          {
            key: "examDataPractical",
            title: response.examDataPractical,
            textarea: true,
            rows: id === 12 ? 3 : 2,
          },
          {
            key: "examDataPracticalPlug",
            title: "Дата и номер протокола по практике",
            mode: "view",
          },
        ]
      : []),
    {
      key: "personConcerned",
      title: response.personConcerned,
      children: getPersonConcernedChildren(response, url, id),
    },
    type === "exchange" && {
      key: "licenseData",
      title: response.licenseData,
      children: ["Номер и дата"],
    },
    id < 14 &&
      id !== 10 &&
      id !== 11 && {
        key: "representative",
        title: response.representative,
        children: [
          "ФИО",
          "Адрес, телефон",
          "Документ, удостоверяющий личность, идентификационный номер",
          "Доверенность",
        ],
      },
    id > 10 &&
      id < 14 && {
        key: "trainingDoc",
        title: response.trainingDoc,
        children: [
          id === 11
            ? "Серия, номер сертификата, выдавшая организация - или самоподготовка"
            : "Срок обучения или самоподготовка",
          id === 11 ? "Срок обучения" : "Серия, номер сертификата, выдавшая организация",
        ],
      },
    id === 13 && {
      key: "republicanLicense",
      title: response.republicanLicense,
      children: ["Номер и дата"],
    },
    type === "duplicate" && {
      key: "regNum",
      title: response.regNum,
      children: ["Регистрационный номер маломерного судна"],
    },
    type === "modif" && {
      key: "regData",
      title: response.regData,
      children: ["Регистрационный номер", "Номер и дата судового билета"],
    },
    !(type === "duplicate" || type === "info") &&
      id < 10 && {
        key: "boatData",
        title: response.boatData,
        children:
          type === "app"
            ? [
                "Название",
                "Год постройки",
                "Заводской (идентификационный) номер",
                "Место стоянки",
                "Количество двигателей",
              ]
            : type === "modif"
            ? ["Название (при  наличии)", "Заводской (идентификационный) номер"]
            : ["Регистрационный номер", "Название (при  наличии)", "Номер и дата судового билета"],
      },
    (type === "app" || type === "modif") &&
      id < 10 && {
        key: "engineData",
        title: response.engineData,
        children: ["Название (марка)", "Заводской (идентификационный) номер"],
      },
    type === "app" &&
      url === 2 &&
      id < 10 && {
        key: "ownership",
        title: response.ownership,
        textarea: true,
        rows: 3,
        children: ["note"],
      },
    type === "app" &&
      id < 10 && {
        key: "rentData",
        title: response.rentData,
        textarea: true,
        rows: 8,
        children: ["note"],
      },
    id !== 10 &&
      id !== 11 && {
        key: "payment",
        title: response.payment,
        textarea: true,
        rows: 4,
        children: [url === 2 || type !== "app" ? "" : "note"],
      },
    type === "app" &&
      id < 10 && {
        key: "warningData",
        title: response.warningData,
        textarea: true,
        rows: 8,
      },
    (id >= 14 || id === 10 || id === 11) && {
      key: "finalData",
      textarea: true,
      rows: 3,
      title: response.finalData,
    },
    {
      key: "patternDate",
      title: "Дата",
      mode: "view",
    },
    {
      key: "patternDateEnd",
      title: id < 10 ? "" : "Подпись заявителя",
      mode: "view",
    },
    type === "modif" && {
      key: "finalData",
      textarea: true,
      rows: 3,
      title: response.finalData,
    },
    ...(type === "app" && id < 14 && id !== 10 && id !== 11
      ? [
          {
            key: id === 12 || id === 13 ? "finalData" : "finalText",
            textarea: true,
            rows: 3,
            title: id === 12 || id === 13 ? response.finalData : response.finalText,
          },
          {
            key: id === 12 || id === 13 ? "licenseDataNum" : "regNum",
            title: id === 12 || id === 13 ? response.licenseDataNum : response.regNum,
          },
          {
            key: "patternNote",
            title: "",
            mode: "view",
          },
          ...(id !== 12
            ? [
                {
                  key: id === 12 || id === 13 ? "licenseDataSaBt" : "ticket",
                  title: id === 12 || id === 13 ? response.licenseDataSaBt : response.ticket,
                },
                {
                  key: "firstUnknown",
                  title: "",
                  mode: "view",
                },
              ]
            : []),
        ]
      : []),
    ...(type === "modif" || (type === "app" && id < 14 && id !== 10 && id !== 11)
      ? [
          {
            key: "secondUnknown",
            title: id === 12 || id === 13 ? "Дата" : "",
            mode: "view",
          },
          {
            key: "thirdUnknown",
            mode: "view",
          },
        ]
      : []),
    ...(id === 1 || id === 2
      ? [
          {
            key: "ticketMark",
            title: response.ticketMark,
          },
          {
            key: "ticketMarkPlug",
            title: "",
            mode: "view",
          },
        ]
      : []),
  ].filter(Boolean);

export const getTypeRequest = (url) => {
  const typePattern = url.split("-").at(-1).split("/")[0];
  const typeRequest = Number(url.at(-1));
  return { typePattern, typeRequest };
};
